export const PASSWORD = {
  OLD_PASSWORD: 'old password',
  NEW_PASSWORD: 'new password',
}

export const USER = {
  EMAIL: 'email',
}